import type { LineaRemito, OrdenParaRemito } from '../api';

/**
 * El texto del producto que propone una orden. Espejo de `lineaDeOrden` en
 * `backend/src/domain/remito.ts`: tiene que dar lo mismo, porque es con lo que
 * se reconoce un renglón que nadie tocó.
 */
export function productoDeOrden(o: OrdenParaRemito): string {
  const nombre = o.descripcion && o.descripcion !== o.articulo ? o.descripcion : o.articulo;
  const bultos =
    o.unidad === 'pallet'
      ? `${o.capachos} ${o.capachos === 1 ? 'pallet completo' : 'pallets completos'}`
      : `${o.capachos} ${o.capachos === 1 ? 'capacho' : 'capachos'}`;
  const piezas = o.unidad === 'pallet' || !o.piezasTotal ? '' : ` · ${o.piezasTotal} piezas`;
  return `${nombre} — ${bultos}${piezas}`;
}

/**
 * Suma los renglones de una orden al remito. El producto que ya está —mismo
 * código y misma unidad— no abre otro renglón: se le suman la cantidad y la
 * orden. Si su texto es el que propuso el sistema se reescribe con lo sumado
 * («5 capachos · 180 piezas»); si alguien lo corrigió a mano, se respeta.
 */
export function sumarRenglones(actuales: LineaRemito[], nuevas: LineaRemito[]): LineaRemito[] {
  const lineas = actuales.map((l) => ({ ...l }));
  for (const n of nuevas) {
    const i = lineas.findIndex(
      (l) => n.codigo && l.codigo === n.codigo && (!l.origen || !n.origen || l.origen.unidad === n.origen.unidad),
    );
    const l = lineas[i];
    if (!l) {
      lineas.push({ ...n });
      continue;
    }
    const intacto = l.origen && l.producto === productoDeOrden(l.origen);
    const origen =
      l.origen && n.origen
        ? {
            ...l.origen,
            capachos: l.origen.capachos + n.origen.capachos,
            piezasTotal:
              l.origen.piezasTotal !== null && n.origen.piezasTotal !== null
                ? l.origen.piezasTotal + n.origen.piezasTotal
                : null,
          }
        : undefined;
    lineas[i] = {
      ...l,
      ordenes: [...new Set([...l.ordenes, ...n.ordenes])],
      cantidad: l.cantidad + n.cantidad,
      producto: intacto && origen ? productoDeOrden(origen) : l.producto,
      origen,
    };
  }
  return lineas;
}
